<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "BarGraphStatisticAttestation",

  components: {
    VueApexCharts,
  },

  props: {
    xaxis: {
      type: Array,
      default: [],
    },

    series: {
      type: Array,
      default: [],
    },

    width: {
      type: [String, Number],
      default: 1024
    },
  },

  data() {
    return {
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      },

      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },

      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
        },
      },

    }
  },


  computed: {

    computedSeries() {
      return this.series;
    },

    computedXaxis() {
      return this.xaxis;
    },

    options() {
      return {
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top',
            },
          }
        },
        xaxis: {
          categories: this.computedXaxis,
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
        },

        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
        },

        legend: this.legend,

        dataLabels: this.dataLabels,

      }
    },
  },

}
</script>

<template>
  <vue-apex-charts
    :width="width"
    :options="options"
    :series="computedSeries"
    height="500px"
    type="bar"
    :style="{'overflow-x': 'auto', 'overflow-y': 'hidden'}"
  />
</template>

<style scoped>

</style>